import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import { RouteSuspense } from "./RouteSuspense";
import { ROUTES } from "./routes";

const HomePage = React.lazy(() => import("../../features/home/pages/HomePage"));
const MarketPage = React.lazy(
  () => import("../../features/market/pages/MarketPage"),
);
const NewsPage = React.lazy(() => import("../../features/news/pages/NewsPage"));
const NewsDetailPage = React.lazy(
  () => import("../../features/news/pages/NewsDetailPage"),
);
const NewsPreviewPage = React.lazy(
  () => import("../../features/news/pages/NewsPreviewPage"),
);
const NewsEditorPage = React.lazy(
  () => import("../../features/news/pages/NewsEditorPage"),
);
const ServersPage = React.lazy(
  () => import("../../features/servers/pages/ServersPage"),
);
const RoadmapPage = React.lazy(
  () => import("../../features/roadmap/pages/RoadmapPage"),
);
const FAQPage = React.lazy(() => import("../../features/faq/pages/FAQPage"));

export default function AppRoutes() {
  return (
    <Routes>
      <Route
        path={ROUTES.HOME}
        element={
          <RouteSuspense>
            <HomePage />
          </RouteSuspense>
        }
      />
      <Route
        path={ROUTES.MARKET}
        element={
          <RouteSuspense>
            <MarketPage />
          </RouteSuspense>
        }
      />
      <Route
        path={ROUTES.NEWS}
        element={
          <RouteSuspense>
            <NewsPage />
          </RouteSuspense>
        }
      />
      <Route
        path={`${ROUTES.NEWS}/:slug`}
        element={
          <RouteSuspense>
            <NewsDetailPage />
          </RouteSuspense>
        }
      />
      <Route
        path={ROUTES.NEWS_PREVIEW}
        element={
          <RouteSuspense>
            <NewsPreviewPage />
          </RouteSuspense>
        }
      />
      <Route
        path={ROUTES.NEWS_EDITOR}
        element={
          <ProtectedRoute requireStaff>
            <RouteSuspense>
              <NewsEditorPage />
            </RouteSuspense>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.NEWS_EDIT}
        element={
          <ProtectedRoute requireStaff>
            <RouteSuspense>
              <NewsEditorPage />
            </RouteSuspense>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.SERVERS}
        element={
          <RouteSuspense>
            <ServersPage />
          </RouteSuspense>
        }
      />
      <Route
        path={ROUTES.ROADMAP}
        element={
          <RouteSuspense>
            <RoadmapPage />
          </RouteSuspense>
        }
      />
      <Route
        path={ROUTES.FAQ}
        element={
          <RouteSuspense>
            <FAQPage />
          </RouteSuspense>
        }
      />
      <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
    </Routes>
  );
}
